import { createContext } from 'react';
import { VisualNotifications } from '@/contexts/visualNotifications/types';

export const VisualNotificationsContext = createContext<VisualNotifications>(
  {} as VisualNotifications
);
VisualNotificationsContext.displayName = 'Visual Notifications';
